import Vue from 'vue'
import config, { API_URL } from '../../config'
import store from '../store'
import { resumenSnackbarColor } from '../util/calidadVouchersEnvio'

export default {
  namespaced: true,

  state: {
    clientes: [],
    clientesTotal: 0,
    archivos: [],
    loading: false,
    importando: false,
    resumenImportacion: null,
    plantilla: null,
    plantillaLoading: false,
    envios: [],
    enviosLoading: false,
    sending: false,
    voucherDefault: null,
    voucherDefaultLoading: false,
    sucursales: [],
    sucursalesLoading: false,
    enriquecimientoLoading: false,
    enriquecimientoByVin: {}
  },

  mutations: {
    set_clientes(state, payload) {
      // Orden: pendientes primero, luego por FechaEvento descendente
      state.clientes = [...payload].sort((a, b) => {
        if (a.VoucherEnviado !== b.VoucherEnviado) {
          return a.VoucherEnviado ? 1 : -1
        }
        const dateA = a.FechaEvento ? new Date(a.FechaEvento).getTime() : 0
        const dateB = b.FechaEvento ? new Date(b.FechaEvento).getTime() : 0
        return dateB - dateA
      })
    },
    set_archivos(state, payload) {
      state.archivos = payload
    },
    set_loading(state, payload) {
      state.loading = payload
    },
    set_importando(state, payload) {
      state.importando = payload
    },
    set_resumenImportacion(state, payload) {
      state.resumenImportacion = payload
    },
    set_plantilla(state, payload) {
      state.plantilla = payload
    },
    set_plantillaLoading(state, payload) {
      state.plantillaLoading = payload
    },
    set_envios(state, payload) {
      state.envios = payload
    },
    set_enviosLoading(state, payload) {
      state.enviosLoading = payload
    },
    set_sending(state, payload) {
      state.sending = payload
    },
    set_voucherDefault(state, payload) {
      state.voucherDefault = payload
    },
    set_voucherDefaultLoading(state, payload) {
      state.voucherDefaultLoading = payload
    },
    set_sucursales(state, payload) {
      state.sucursales = payload
    },
    set_sucursalesLoading(state, payload) {
      state.sucursalesLoading = payload
    },
    set_clientes_total(state, payload) {
      state.clientesTotal = payload
    },
    set_enriquecimiento_loading(state, payload) {
      state.enriquecimientoLoading = payload
    },
    merge_enriquecimiento(state, payload) {
      const map = new Map(payload.map(e => [String(e.VIN || '').trim().toUpperCase(), e]))
      payload.forEach(e => {
        const vinKey = String(e.VIN || '').trim().toUpperCase()
        if (vinKey) Vue.set(state.enriquecimientoByVin, vinKey, e)
      })
      state.clientes.forEach((c, idx) => {
        const vinKey = String(c.VIN || '').trim().toUpperCase()
        const enrich = map.get(vinKey)
        if (enrich) {
          Vue.set(state.clientes, idx, {
            ...c,
            Patente: enrich.Patente ?? c.Patente,
            Modelo: enrich.Modelo ?? c.Modelo,
            EmailAutoDealer: enrich.EmailAutoDealer ?? c.EmailAutoDealer,
            TelefonoAutoDealer: enrich.TelefonoAutoDealer ?? c.TelefonoAutoDealer,
            SaiClienteID: enrich.SaiClienteID ?? c.SaiClienteID,
            SucursalId: enrich.SucursalId ?? c.SucursalId,
            VendedorNombre: enrich.VendedorNombre ?? c.VendedorNombre
          })
        }
      })
    },
    apply_enriquecimiento_cache(state) {
      state.clientes.forEach((c, idx) => {
        const vinKey = String(c.VIN || '').trim().toUpperCase()
        const cached = state.enriquecimientoByVin[vinKey]
        if (cached) {
          Vue.set(state.clientes, idx, {
            ...c,
            Patente: cached.Patente ?? c.Patente,
            Modelo: cached.Modelo ?? c.Modelo,
            EmailAutoDealer: cached.EmailAutoDealer ?? c.EmailAutoDealer,
            TelefonoAutoDealer: cached.TelefonoAutoDealer ?? c.TelefonoAutoDealer,
            SaiClienteID: cached.SaiClienteID ?? c.SaiClienteID,
            SucursalId: cached.SucursalId ?? c.SucursalId,
            VendedorNombre: cached.VendedorNombre ?? c.VendedorNombre
          })
        }
      })
    },
    clear_enriquecimiento_cache(state) {
      state.enriquecimientoByVin = {}
    }
  },

  actions: {
    async fetchClientes({ commit }, filtros = {}) {
      commit('set_loading', true)
      try {
        const params = new URLSearchParams()
        Object.entries(filtros).forEach(([key, value]) => {
          if (value !== null && value !== undefined && value !== '') {
            params.append(key, value)
          }
        })

        const response = await fetch(`${API_URL}/calidad/vouchers/clientes?${params.toString()}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: store.state.token
          }
        })

        const data = await response.json()

        if (data.exito === 1) {
          const lista = Array.isArray(data.data) ? data.data : []
          commit('set_clientes', lista)
          if (data.total !== undefined && data.total !== null) {
            commit('set_clientes_total', data.total)
          } else {
            commit('set_clientes_total', lista.length)
          }
          commit('apply_enriquecimiento_cache')
          return data
        } else {
          store.dispatch('show_snackbar', {
            text: data.message || 'Error al obtener clientes',
            color: 'error'
          })
          return data
        }
      } catch (error) {
        store.dispatch('show_snackbar', {
          text: 'Error de conexión al obtener clientes',
          color: 'error'
        })
        return { exito: 0, error: error.message }
      } finally {
        commit('set_loading', false)
      }
    },

    async enriquecerClientes({ commit, state }, { vins }) {
      if (!vins || !Array.isArray(vins) || vins.length === 0) {
        return { exito: 0, message: 'vins vacío' }
      }
      commit('set_enriquecimiento_loading', true)
      try {
        const response = await fetch(`${API_URL}/calidad/vouchers/clientes/enriquecimiento`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: store.state.token
          },
          body: JSON.stringify({ vins })
        })
        const data = await response.json()
        if (data.exito === 1 && Array.isArray(data.data)) {
          commit('merge_enriquecimiento', data.data)
        } else if (data.exito !== 1) {
          store.dispatch('show_snackbar', {
            text: data.message || 'Error al enriquecer datos SAI',
            color: 'error'
          })
        }
        return data
      } catch (error) {
        store.dispatch('show_snackbar', {
          text: 'Error de conexión al enriquecer datos SAI',
          color: 'error'
        })
        return { exito: 0, error: error.message }
      } finally {
        commit('set_enriquecimiento_loading', false)
      }
    },

    // Alias for spec compatibility
    async fetchEnriquecimiento(ctx, payload) {
      return ctx.dispatch('enriquecerClientes', payload)
    },

    async fetchArchivos({ commit }, filtros = {}) {
      try {
        const params = new URLSearchParams()
        Object.entries(filtros).forEach(([key, value]) => {
          if (value !== null && value !== undefined && value !== '') {
            params.append(key, value)
          }
        })

        const response = await fetch(`${API_URL}/calidad/vouchers/archivos?${params.toString()}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: store.state.token
          }
        })

        const data = await response.json()

        if (data.exito === 1) {
          commit('set_archivos', data.data || [])
        }
      } catch (error) {
        store.dispatch('show_snackbar', {
          text: 'Error de conexión al obtener archivos',
          color: 'error'
        })
      }
    },

    async importarArchivo({ commit, dispatch }, payload) {
      commit('set_importando', true)
      try {
        const response = await fetch(`${API_URL}/calidad/vouchers/importar`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: store.state.token
          },
          body: JSON.stringify(payload)
        })

        const data = await response.json()

        if (data.exito === 1) {
          commit('set_resumenImportacion', data.data ? data.data.resumen : null)
          return data
        } else {
          store.dispatch('show_snackbar', {
            text: data.message || 'Error al importar el archivo',
            color: 'error'
          })
          return data
        }
      } catch (error) {
        store.dispatch('show_snackbar', {
          text: 'Error de conexión al importar el archivo',
          color: 'error'
        })
        return { exito: 0, error: error.message }
      } finally {
        commit('set_importando', false)
      }
    },

    limpiarResumen({ commit }) {
      commit('set_resumenImportacion', null)
    },

    async updateCliente({ dispatch }, { id, Email, ComentarioOrigen, Nombre }) {
      try {
        const body = {}
        if (Email !== undefined) body.Email = Email
        if (ComentarioOrigen !== undefined) body.ComentarioOrigen = ComentarioOrigen
        if (Nombre !== undefined) body.Nombre = Nombre

        const response = await fetch(`${API_URL}/calidad/vouchers/clientes/${id}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            Authorization: store.state.token
          },
          body: JSON.stringify(body)
        })

        const data = await response.json()

        if (data.exito === 1) {
          store.dispatch('show_snackbar', {
            text: data.message || 'Datos actualizados',
            color: 'success'
          })
          return data
        } else {
          store.dispatch('show_snackbar', {
            text: data.message || 'Error al actualizar los datos',
            color: 'error'
          })
          return data
        }
      } catch (error) {
        store.dispatch('show_snackbar', {
          text: 'Error de conexión al actualizar',
          color: 'error'
        })
        return { exito: 0, error: error.message }
      }
    },

    async buscarOCrearCliente({ dispatch }, { q, Tipo }) {
      try {
        const response = await fetch(`${API_URL}/calidad/vouchers/clientes/buscar-o-crear`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: store.state.token
          },
          body: JSON.stringify({ q, Tipo })
        })

        const data = await response.json()
        return data
      } catch (error) {
        return { exito: 0, error: error.message }
      }
    },

    async createCliente({ dispatch }, payload) {
      try {
        const response = await fetch(`${API_URL}/calidad/vouchers/clientes`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: store.state.token
          },
          body: JSON.stringify(payload)
        })

        const data = await response.json()

        if (data.exito === 1) {
          store.dispatch('show_snackbar', {
            text: data.message || 'Cliente creado correctamente',
            color: 'success'
          })
          return data
        } else {
          store.dispatch('show_snackbar', {
            text: data.message || 'Error al crear el cliente',
            color: 'error'
          })
          return data
        }
      } catch (error) {
        store.dispatch('show_snackbar', {
          text: 'Error de conexión al crear el cliente',
          color: 'error'
        })
        return { exito: 0, error: error.message }
      }
    },

    async getExistingVoucher({ dispatch }, { EncuestaClienteID, Tipo }) {
      try {
        const response = await fetch(`${API_URL}/calidad/vouchers/existing?EncuestaClienteID=${EncuestaClienteID}&Tipo=${encodeURIComponent(Tipo)}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: store.state.token
          }
        })

        const data = await response.json()
        return data
      } catch (error) {
        return { exito: 0, error: error.message }
      }
    },

    async registrarVoucher({ dispatch }, payload) {
      try {
        const response = await fetch(`${API_URL}/calidad/vouchers/registrar`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: store.state.token
          },
          body: JSON.stringify(payload)
        })

        const data = await response.json()
        return data
      } catch (error) {
        return { exito: 0, error: error.message }
      }
    },

    async deleteArchivo({ dispatch }, { id }) {
      try {
        const response = await fetch(`${API_URL}/calidad/vouchers/archivos/${id}`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: store.state.token
          }
        })

        const data = await response.json()

        if (data.exito === 1) {
          store.dispatch('show_snackbar', {
            text: data.message || 'Archivo eliminado',
            color: 'success'
          })
          return data
        } else {
          store.dispatch('show_snackbar', {
            text: data.message || 'Error al eliminar el archivo',
            color: 'error'
          })
          return data
        }
      } catch (error) {
        store.dispatch('show_snackbar', {
          text: 'Error de conexión al eliminar el archivo',
          color: 'error'
        })
        return { exito: 0, error: error.message }
      }
    },

    async updateClienteAutoDealer({ dispatch }, { id, Email, Telefono }) {
      try {
        const body = {}
        if (Email !== undefined && !String(Email).trim()) {
          store.dispatch('show_snackbar', {
            text: 'El campo email no puede estar vacío',
            color: 'warning'
          })
          return { exito: 0, message: 'El campo email no puede estar vacío' }
        }
        if (Email !== undefined) body.Email = Email
        if (Telefono !== undefined) body.Telefono = Telefono

        const response = await fetch(`${API_URL}/calidad/vouchers/clientes/${id}/autodealer`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            Authorization: store.state.token
          },
          body: JSON.stringify(body)
        })

        const data = await response.json()
        const normalizarMensaje = (mensaje, fallback) => (mensaje || fallback).replace(/Sai/g, 'AutoDealer')

        if (data.exito === 1) {
          store.dispatch('show_snackbar', {
            text: normalizarMensaje(data.message, 'Datos actualizados en AutoDealer'),
            color: 'success'
          })
          return data
        } else {
          store.dispatch('show_snackbar', {
            text: normalizarMensaje(data.message, 'Error al actualizar en AutoDealer'),
            color: 'error'
          })
          return data
        }
      } catch (error) {
        store.dispatch('show_snackbar', {
          text: 'Error de conexión al actualizar en AutoDealer',
          color: 'error'
        })
        return { exito: 0, error: error.message }
      }
    },

    // -----------------------------------------------------------------------
    // Voucher email actions
    // -----------------------------------------------------------------------
    async fetchPlantilla({ commit }, Tipo) {
      commit('set_plantillaLoading', true)
      try {
        const response = await fetch(`${API_URL}/calidad/vouchers/plantilla?Tipo=${encodeURIComponent(Tipo)}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: store.state.token
          }
        })

        const data = await response.json()

        if (data.exito === 1) {
          commit('set_plantilla', data.data)
        } else {
          commit('set_plantilla', null)
          store.dispatch('show_snackbar', {
            text: data.message || 'Error al obtener plantilla',
            color: 'error'
          })
        }
      } catch (error) {
        commit('set_plantilla', null)
        store.dispatch('show_snackbar', {
          text: 'Error de conexión al obtener plantilla',
          color: 'error'
        })
      } finally {
        commit('set_plantillaLoading', false)
      }
    },

    async savePlantilla({ commit }, { Tipo, Asunto, MensajeHtml }) {
      try {
        const response = await fetch(`${API_URL}/calidad/vouchers/plantilla`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            Authorization: store.state.token
          },
          body: JSON.stringify({ Tipo, Asunto, MensajeHtml })
        })

        const data = await response.json()

        if (data.exito === 1) {
          store.dispatch('show_snackbar', {
            text: 'Plantilla guardada correctamente',
            color: 'success'
          })
          return data
        } else {
          store.dispatch('show_snackbar', {
            text: data.message || 'Error al guardar plantilla',
            color: 'error'
          })
          return data
        }
      } catch (error) {
        store.dispatch('show_snackbar', {
          text: 'Error de conexión al guardar plantilla',
          color: 'error'
        })
        return { exito: 0, error: error.message }
      }
    },

    async enviarVouchers({ commit }, payload) {
      commit('set_sending', true)
      const silent = payload.__silent === true
      delete payload.__silent
      try {
        const response = await fetch(`${API_URL}/calidad/vouchers/enviar`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: store.state.token
          },
          body: JSON.stringify(payload)
        })

        const data = await response.json()

        if (data.exito === 1) {
          if (!silent) {
            store.dispatch('show_snackbar', {
              text: data.message || 'Vouchers enviados',
              color: resumenSnackbarColor(data.data && data.data.resumen)
            })
          }
          return data
        } else {
          if (!silent) {
            store.dispatch('show_snackbar', {
              text: data.message || 'Error al enviar vouchers',
              color: 'error'
            })
          }
          return data
        }
      } catch (error) {
        if (!silent) {
          store.dispatch('show_snackbar', {
            text: 'Error de conexión al enviar vouchers',
            color: 'error'
          })
        }
        return { exito: 0, error: error.message }
      } finally {
        commit('set_sending', false)
      }
    },

    async marcarEnviado({ dispatch }, { clienteId, tipo, comentario, silent = false }) {
      try {
        const response = await fetch(`${API_URL}/calidad/vouchers/marcar-enviado`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: store.state.token
          },
          body: JSON.stringify({ clienteId, tipo, comentario })
        })

        const data = await response.json()

        if (data.exito === 1) {
          if (!silent) {
            store.dispatch('show_snackbar', {
              text: data.message || 'Cliente marcado como enviado',
              color: 'success'
            })
          }
          return data
        } else {
          if (!silent) {
            store.dispatch('show_snackbar', {
              text: data.message || 'Error al marcar como enviado',
              color: 'error'
            })
          }
          return data
        }
      } catch (error) {
        if (!silent) {
          store.dispatch('show_snackbar', {
            text: 'Error de conexión al marcar como enviado',
            color: 'error'
          })
        }
        return { exito: 0, error: error.message }
      }
    },

    async marcarNoEnviado({ dispatch }, { clienteId, tipo }) {
      try {
        const response = await fetch(`${API_URL}/calidad/vouchers/marcar-no-enviado`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: store.state.token
          },
          body: JSON.stringify({ clienteId, tipo })
        })

        const data = await response.json()

        if (data.exito === 1) {
          store.dispatch('show_snackbar', {
            text: data.message || 'Cliente marcado como no enviado',
            color: 'success'
          })
          return data
        } else {
          store.dispatch('show_snackbar', {
            text: data.message || 'Error al marcar como no enviado',
            color: 'error'
          })
          return data
        }
      } catch (error) {
        store.dispatch('show_snackbar', {
          text: 'Error de conexión al marcar como no enviado',
          color: 'error'
        })
        return { exito: 0, error: error.message }
      }
    },

    async configurarUsosDisponibles({ dispatch }, { clienteId, usos }) {
      try {
        const response = await fetch(`${API_URL}/calidad/vouchers/usos-disponibles`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: store.state.token
          },
          body: JSON.stringify({ clienteId, usos })
        })

        const data = await response.json()

        if (data.exito === 1) {
          store.dispatch('show_snackbar', {
            text: data.message || 'Usos disponibles configurados',
            color: 'success'
          })
          return data
        } else {
          store.dispatch('show_snackbar', {
            text: data.message || 'Error al configurar los usos disponibles',
            color: 'error'
          })
          return data
        }
      } catch (error) {
        store.dispatch('show_snackbar', {
          text: 'Error de conexión al configurar los usos disponibles',
          color: 'error'
        })
        return { exito: 0, error: error.message }
      }
    },
    
    // -----------------------------------------------------------------------
    // Voucher default actions
    // -----------------------------------------------------------------------
    async fetchSucursales({ commit }) {
      commit('set_sucursalesLoading', true)
      try {
        const response = await fetch(`${API_URL}/calidad/vouchers/sucursales`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: store.state.token
          }
        })
        const data = await response.json()
        if (data.exito === 1) {
          commit('set_sucursales', data.data || [])
        } else {
          store.dispatch('show_snackbar', {
            text: data.message || 'Error al cargar sucursales',
            color: 'warning'
          })
        }
      } catch (error) {
        console.error('[calidadVouchers] Error fetching sucursales:', error)
        store.dispatch('show_snackbar', {
          text: 'Error de conexión al cargar sucursales',
          color: 'error'
        })
      } finally {
        commit('set_sucursalesLoading', false)
      }
    },

    async fetchVoucherDefault({ commit }, params) {
      commit('set_voucherDefaultLoading', true)
      try {
        // Backward compatible: if params is a string, convert to object
        const tipo = typeof params === 'string' ? params : params.Tipo
        const sucursalId = typeof params === 'object' ? params.SucursalId : undefined

        let url = `${API_URL}/calidad/vouchers/voucher-default?Tipo=${encodeURIComponent(tipo)}`
        if (sucursalId) {
          url += `&SucursalId=${encodeURIComponent(sucursalId)}`
        }

        const response = await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: store.state.token
          }
        })

        const data = await response.json()

        if (data.exito === 1) {
          commit('set_voucherDefault', data.data)
        } else {
          commit('set_voucherDefault', null)
        }
      } catch (error) {
        commit('set_voucherDefault', null)
      } finally {
        commit('set_voucherDefaultLoading', false)
      }
    },

    async saveVoucherDefault({ commit }, { Tipo, Titulo, DiasValidez, SucursalId }) {
      try {
        const body = { Tipo, Titulo, DiasValidez }
        if (SucursalId) {
          body.SucursalId = SucursalId
        }
        const response = await fetch(`${API_URL}/calidad/vouchers/voucher-default`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            Authorization: store.state.token
          },
          body: JSON.stringify(body)
        })

        const data = await response.json()

        if (data.exito === 1) {
          store.dispatch('show_snackbar', {
            text: 'Voucher por defecto guardado correctamente',
            color: 'success'
          })
          return data
        } else {
          store.dispatch('show_snackbar', {
            text: data.message || 'Error al guardar voucher por defecto',
            color: 'error'
          })
          return data
        }
      } catch (error) {
        store.dispatch('show_snackbar', {
          text: 'Error de conexión al guardar voucher por defecto',
          color: 'error'
        })
        return { exito: 0, error: error.message }
      }
    },

    async fetchPermisos() {
      try {
        const response = await fetch(`${API_URL}/calidad/vouchers/permisos`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: store.state.token
          }
        })
        const data = await response.json()
        if (data.exito === 1) {
          return data.permisos
        }
        return { lectura: false, gestion: false, consultas: false }
      } catch (error) {
        console.error('[calidadVouchers] Error fetching permisos:', error)
        return { lectura: false, gestion: false, consultas: false }
      }
    },

    async fetchEnvios({ commit }, { Tipo, limit } = {}) {
      commit('set_enviosLoading', true)
      try {
        const params = new URLSearchParams()
        if (Tipo) params.append('Tipo', Tipo)
        if (limit) params.append('limit', limit)

        const response = await fetch(`${API_URL}/calidad/vouchers/envios?${params.toString()}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: store.state.token
          }
        })

        const data = await response.json()

        if (data.exito === 1) {
          commit('set_envios', data.data || [])
        } else {
          store.dispatch('show_snackbar', {
            text: data.message || 'Error al obtener envíos',
            color: 'error'
          })
        }
      } catch (error) {
        store.dispatch('show_snackbar', {
          text: 'Error de conexión al obtener envíos',
          color: 'error'
        })
      } finally {
        commit('set_enviosLoading', false)
      }
    }
  }
}
